<template>
  <section>
    <div class="container">
      <p>Unauthorized Access</p>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'Unauthorized',
  props: {
  },
  computed: {
    ...mapState('poll', ['basePath']),
    ...mapGetters('poll', ['unauthorizedLink'])
  }
}
</script>

<style scoped lang="scss">
section {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
}

.container {
  display: flex;
  justify-content: center;
}

.style-bbl,
.style-veev {

  section {
    display: none;
  }
}
</style>
